//#region IMPORTAÇÕES
import { Component, Input, OnInit } from "@angular/core";
import { ProductService } from "../../../shared/services/product.service";
import { ToastrService } from "ngx-toastr";
import { DetalharprodutoComponent } from "../../detalharproduto/detalharproduto.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LocationPickerComponent } from "src/app/shared/components/location-picker/location-picker.component";
import { EcomerceService } from "src/app/shared/services/ecommerce.service";
import { Router } from "@angular/router";
import { AppService } from "../../../app.service";
//#endregion

@Component({
  selector: "app-produtoshome",
  templateUrl: "./produtoshome.component.html",
  styleUrls: ["./produtoshome.component.scss"],
})
export class ProdutoshomeComponent implements OnInit {
  @Input() location: string;
  products: any;
  newItems: any[] = [];

  constructor(
    private productService: ProductService,
    private modalService: NgbModal,
    public toastrService: ToastrService,
    private ecomerceService: EcomerceService,
    private router: Router,
    public appService: AppService
  ) {}

  ngOnInit(): void {
    if (!this.productService.requestDone || !localStorage.getItem("location")) {
      this.validateLocation();
    } else {
      this.productService.getProducts.subscribe((data) => {
        this.sortProducts(data);
      });
    }
  }

  validateLocation() {
    if (localStorage.getItem("linkDireto") === "true") {
      this.listarProdutos();
    } else {
      const modalRef = this.modalService.open(
        LocationPickerComponent,
        this.appService.optionsModalMedium
      );
      modalRef.result.then((result) => {
        this.location = result;
        this.listarProdutos();
      });
    }
  }

  listarProdutos() {
    this.ecomerceService
      .listarProdutos(localStorage.getItem("location"))
      .subscribe(
        (data) => {
          this.productService.setProducts(
            data,
            localStorage.getItem("location")
          );

          this.sortProducts(data);
        },
        (error) => {
          console.error("Erro ao listar produtos:", error);
        }
      );
  }

  private sortProducts(data: any) {
    this.products = data;

    //   // obtem 50 produtos aleatórios JAVASCRIPT RENATO
    for (var i = 0; i < 12; i++) {
      var idx = Math.floor(Math.random() * this.products.length);
      this.newItems.push(this.products[idx]);
      //this.products.splice(idx, 1);
    }
  }

  lupa(id: number) {
    this.router.navigate([`shop/product/left/sidebar/${id}`]);
  }

  addToCart(product: any) {
    this.productService.addToCart(product);
  }

  detalharProduto(product: any) {
    const modalRef = this.modalService.open(DetalharprodutoComponent, {
      size: "lg",
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      windowClass: "Quickview",
    });

    modalRef.componentInstance.product = product;
    modalRef.componentInstance.currency = this.productService.Currency;
  }

  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  addToCompare(product: any) {
    this.productService.addToCompare(product);
  }
}
